import { useCallback } from "react";

import groupBy from "lodash/groupBy";
import { useMutation } from "react-query";
import { getLanContent } from "utils";

import { masterDataDistrictListService } from "./services";

export const useDistrictListByIds = () => {
  const { mutateAsync: getListDistrict } = useMutation({
    mutationKey: "masterDataDistrictListServiceOption",
    mutationFn: masterDataDistrictListService,
  });

  const getListDistrictsByIds = useCallback(
    async (ids: number[], province: number) => {
      try {
        if (!ids?.length && !province) return {};

        const data = await getListDistrict({ ids, provinceId: province });
        const dataTransform = data?.data?.items?.map((item) => ({
          id: item.id,
          name: getLanContent(item, "name"),
        }));
        return groupBy(dataTransform, "id") || [];
      } catch {
        return {};
      }
    },
    [getListDistrict]
  );

  return {
    getListDistrictsByIds,
  };
};
